import {
  IPlatformSocial,
  IPlatformSocialData,
  PLATFORM_SOCIAL_NAME_MAX_LENGTH
} from './index'

export class PlatformSocial implements IPlatformSocial {
  readonly id?: number
  name: string
  ref?: string

  constructor(data?: IPlatformSocialData) {
    this.id = data?.id
    this.name = data?.name || ''
    this.ref = data?.ref
  }

  validate(): boolean {
    return this.validateName() && this.validateRef()
  }

  validateName(): boolean {
    let name = this.name
    return !!name && name.length <= PLATFORM_SOCIAL_NAME_MAX_LENGTH
  }

  validateRef(): boolean {
    return !!this.ref?.length
  }

  get key(): string {
    let id = this.id;
    return (id ? (id + '-') : '') + this.name;
  }
}
